import { getContrastRatio, hslToRgb } from '@mui/material/styles'

const GOLDEN_ANGLE = 137.508
const WCAG_AA_NORMAL_TEXT = 4.5
const WHITE = '#ffffff'
const BLACK = '#000000'

type TagColorEntry = { main: string; contrastText: string }

const pickContrastText = (main: string): string =>
  getContrastRatio(WHITE, main) >= WCAG_AA_NORMAL_TEXT ? WHITE : BLACK

export const withContrastText = <K extends string>(
  mains: Record<K, string>,
): Record<K, TagColorEntry> => {
  const entries = Object.entries(mains) as [K, string][]

  return Object.fromEntries(
    entries.map(([k, main]) => [k, { main, contrastText: pickContrastText(main) }]),
  ) as Record<K, TagColorEntry>
}

const generateItemSetFallbackColor = (index: number): TagColorEntry => {
  const hue = (index * GOLDEN_ANGLE) % 360
  const lightness = index % 2 === 0 ? 50 : 62
  const main = hslToRgb(`hsl(${hue}, 65%, ${lightness}%)`)

  return { main, contrastText: pickContrastText(main) }
}

const ITEM_SET_FALLBACK_COUNT = 82

type DynKey = `ITEM_SET_DYN_${number}`

export const generateItemSetFallbackColors = (): Record<DynKey, TagColorEntry> => {
  const entries = Array.from({ length: ITEM_SET_FALLBACK_COUNT }, (_, i) => [
    `ITEM_SET_DYN_${i}` as DynKey,
    generateItemSetFallbackColor(i),
  ])

  return Object.fromEntries(entries) as Record<DynKey, TagColorEntry>
}
